module.exports = __webpack_public_path__ + "img/cavena-studio.16eeb5c0.png";